<template>
    <div v-if="getSysMailInfo.data">
        <sys-mail-header page-name="システム通知"></sys-mail-header>
        <sys-mail-group ref="group" :list="getSysMailInfo.data"></sys-mail-group>
        <sys-mail-temp ref="temp" :list="getSysMailInfo.data.mail_temp_info" :proj="getSysMailInfo.data.mail_proj_info"></sys-mail-temp>
        <!-- メッセージ -->
        <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOk"></info-msg>
    </div>
</template>

<script>
    import SysMailHeader from 'pages/commons/header/Header'
    import SysMailGroup from './components/SelectGroup'
    import SysMailTemp from './components/SelectTemp'

    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            SysMailHeader,
            SysMailGroup,
            SysMailTemp,
            InfoMsg
        },
        created () {
            this.loadSysMailInfo()
        },
        activated () {
            this.loadSysMailInfo()
        },
        data () {
            return {
                // メッセージ用
                lev: 0,
                msg: "",
                msgKey: "",
                selectId: "",
                tempInfo: {},
            }
        },
        methods: {
            loadSysMailInfo () {
                this.$store.dispatch('loadSysMailInfo')
            },
            openMsg (lev, msg, key='', id='') {
                this.lev = lev
                this.msg = msg
                this.msgKey = key
                this.selectId = id
                this.$refs.msg.openThis()
            },
            sysMailSend () {
                let from = this.$refs.group.getMailFrom()
                let fromNm = this.$refs.group.getMailFromNm()
                let type = this.$refs.group.getGroupType()
                let group = this.$refs.group.getMailGroup()
                let reqInfo = this.$refs.temp.getMailTemp()
                let file = this.$refs.temp.getFile()
                reqInfo.from = from
                reqInfo.fromNm = fromNm
                reqInfo.type = type
                reqInfo.group = group

                // Formじゃないとfile取得できない
                let formData = this.makeFormData(reqInfo, file)

                this.$store.dispatch('sysMailSend', formData)
            },
            makeFormData (form, file) {
                let formData = new FormData();
                formData.append('file', file)

                Object.keys(form).forEach(function (key) {
                    let val = form[key]
                    formData.append(key, JSON.stringify(val))
                })
                return formData
            },
            msgOk () {
                if (this.msgKey == 'groupDel') {
                    this.$store.dispatch('mailGroupEditDel', {
                        type: this.$refs.group.getGroupType(),
                        id: this.selectId,
                    })
                }
                if (this.msgKey == 'tempDel') {
                    this.$store.dispatch('mailTempDel', {
                        id: this.selectId,
                    })
                }
            },
        },
        watch: {
            getSysMailInfoLoadStatus (status) {
                if (status == 1) {
                    this.$store.dispatch('startProgress')
                }
                if (status == 2) {
                    this.$store.dispatch('doneProgress')
                }
                if (status == 3) {
                    this.$store.dispatch('doneProgress')
                }
            }
        },
        computed: {
            ...mapGetters(['getSysMailInfoLoadStatus', 'getSysMailInfo'])
        }

    }
</script>

<style lang="stylus" scoped>

</style>


